module.exports = __webpack_public_path__ + "img/HCBundle.4af20d73.webp";